/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/extensions */
/* eslint-disable no-param-reassign */

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ArticleDetailState } from 'Types/GlobalTypes';
import { AddToFavoriteRequest, ArticleDetailRequest } from 'Types/RequestBodies';
import { ArticleDetailResponse, DeepLinkResponse } from 'Types/ArticleTypes';

export const initialState: ArticleDetailState = {
  loading: false,
  articleId: 0,
  article: null,
  deepLinkLoading: false,
  deepLink: '',
  articleDrawerOpen: false,
};

const articleDetailSlice = createSlice({
  name: 'articleDetail',
  initialState,
  reducers: {
    getArticle(state, action: PayloadAction<ArticleDetailRequest>) {
      state.loading = true;
      state.article = null;
      state.articleId = 0;
    },

    setArticleDetail(state, action:PayloadAction<ArticleDetailResponse>) {
      const { payload } = action;
      state.loading = false;
      state.article = payload.response;
      state.articleId = payload.response.articleId;
    },
    getArticleDeepLink(state, action: PayloadAction<number>) {
      state.deepLinkLoading = true;
    },
    setArticleDeepLink(state, action: PayloadAction<DeepLinkResponse>) {
      state.deepLinkLoading = false;
      const { response: { articleLink } } = action.payload;
      state.deepLink = articleLink;
    },
    addToFavoriteSuccess(state, action: PayloadAction<AddToFavoriteRequest>) {
      const { articleId, favoriteFlag } = action.payload;
      if (state.article) { state.article.isFavorite = favoriteFlag === 1; }
    },
    setArticleDrawerOpen(state, action: PayloadAction<boolean>) {
      state.articleDrawerOpen = action.payload;
    },
  },

});

export const { actions, reducer, name: sliceKey } = articleDetailSlice;
